import { useQuery } from "@tanstack/react-query";
import { ApiGetBalanceV2 } from "@/api";
import { useUserStore } from "@/store/useUserStore";

export const useBalanceV2 = () => {
  const { userInfo } = useUserStore();
  const { data, isLoading, error } = useQuery({
    queryKey: ["balanceV2"],
    queryFn: async () => {
      const res = await ApiGetBalanceV2();
      console.log("useBalanceV2", res.data);
      return res.data;
    },
    enabled: !!userInfo?.uid,
    refetchInterval: 1000 * 5,
  });
  const getTokenBalanceData = (tokenAddress: string) => {
    if (!data) return null;
    return data?.items?.find(item => item.coinContract === tokenAddress);
  };
  return { data, isLoading, error, getTokenBalanceData };
};
